<div class="ms-sm-0 ms-4">
  <span [ngStyle]="{ color: reportStatus ? reportStatus.color : '' }">{{
    reportStatus?.statusText
  }}</span>
</div>
